import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_VOICES_DETAILS_PAGE = createFcmDetails('supporter_voices_details_page', {
	owner: /* TODO */ '',
	context: /* TODO */ '',
	description: /* TODO */ '',
	import: false,
	template: {
		enabled: false,
		activatedPercentage: 0,
		blocklist: [],
	},
});
